<template lang="pug">
  .common-load-box
    slot(name='skeleton' v-if="!showModule")
    .common-load-box-module(v-show="showModule")
      slot(name='module')
</template>

<script>
export default {
  name: 'CommonLoadBox',
  props: {
    // 是否加载完成
    loaded: {
      type: Boolean,
      default: false,
    },
    // 是否需要超时
    needTimeout: {
      type: Boolean,
      default: true,
    },
    // 超时时间
    timeout: {
      type: Number,
      default: 10000,
    },
  },
  data() {
    return {
      // 是否显示模块
      showModule: false,
      // 超时定时器
      timer: null,
    };
  },
  watch: {
    loaded: {
      handler(v) {
        if (v && !this.showModule) {
          this.showModule = true;
          this.clearTimer();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.needTimeout) {
      this.timer = setTimeout(() => {
        this.showModule = true;
        this.timer = null;
      }, this.timeout);
    }
  },
  destroyed() {
    this.clearTimer();
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>
